import Annotation from 'components/Annotation'
import { AnnotationTextMarker as TM } from 'components/Annotation/AnnotationTextMarker'
import { CircleAnnotation } from 'components/Annotation/CircleAnnotation'
const isMobile = window.innerWidth < 712

export const geneva_data: CityData = {
  name: 'Genève',
  bfsid: '6621',
  sat_images: [
    {
      label: 'Moins aisés - Pâquis',
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_sat_poor_mob.jpg')
        : require('../../../Content/Maps/maps_6621_sat_poor.jpg'),
    },
    {
      label: 'Plus aisés - Vieille-Ville',
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_sat_rich_mob.jpg')
        : require('../../../Content/Maps/maps_6621_sat_rich.jpg'),
    },
  ],
  elements: [
    {
      id: 'zh_1',
      text: (
        <>
          <p>
            Dans la commune de Genève même, les divisions entre les quartiers
            d'habitation des pauvres et des riches sont moins marquées que dans
            les grandes villes alémaniques. La répartition ressemble souvent à
            une mosaïque, avec un mélange de maisons individuelles et
            d'immeubles sociaux.
          </p>  
        </>
      ),
      annotations: [
        {
          content: <Annotation priority={3}>Les Franchises</Annotation>,
          position: { x: 6, y: 35 },
          position_mobile: { x: 6, y: 38 },
        },
        {
          content: <Annotation priority={3}>Eaux-Vives</Annotation>,
          position: { x: 60, y: 48 },
          position_mobile: { x: 53, y: 50 },
        },
        {
          content: <Annotation priority={3}>Petit-Saconnex</Annotation>,
          position: { x: 40, y: 28 },
          position_mobile: { x: 32, y: 31 },
        },
        {
          content: <Annotation priority={3}>Pâquis</Annotation>,
          position: { x: 60, y: 40 },
          position_mobile: { x: 59, y: 44 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_all_mob.jpg')
        : require('../../../Content/Maps/maps_6621_all.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_6621_all_mob_dm.jpg')
        : require('../../../Content/Maps/maps_6621_all_dm.jpg'),
    },
    {
      id: 'zh_2',
      text: (
        <>
          <p>
            Les habitantes et habitants de la <TM prio={2}>Vieille-Ville</TM>{' '}
            figurent parmi les plus riches de Genève. Avec ses hôtels
            particuliers, la fameuse rue des Granges en est emblématique.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 30 : 60}
              angle={isMobile ? 120 : 230}
            >
              Vieille-Ville
            </CircleAnnotation>
          ),
          position: { x: 56, y: 56 },
          position_mobile: { x: 57, y: 56 },
        },
        {
          content: <Annotation priority={3}>Les Franchises</Annotation>,
          position: { x: 6, y: 35 },
          position_mobile: { x: 6, y: 38 },
        },
        {
          content: <Annotation priority={3}>Eaux-Vives</Annotation>,
          position: { x: 60, y: 48 },
          // position_mobile: { x: 53, y: 50 },
        },
        {
          content: <Annotation priority={3}>Petit-Saconnex</Annotation>,
          position: { x: 40, y: 28 },
          position_mobile: { x: 32, y: 31 },
        },
        {
          content: <Annotation priority={3}>Pâquis</Annotation>,
          position: { x: 60, y: 40 },
          position_mobile: { x: 59, y: 44 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_rich_mob.jpg')
        : require('../../../Content/Maps/maps_6621_rich.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_6621_rich_mob_dm.jpg')
        : require('../../../Content/Maps/maps_6621_rich_dm.jpg'),
    },
    {
      id: 'zh_3',
      text: (
        <>
          <p>
            On trouve des concentrations isolées de personnes plus pauvres dans
            certains secteurs du quartier{' '}
            <TM prio={3}>Saint-Jean Charmilles</TM> ou des{' '}
            <TM prio={3}>Pâquis.</TM>
          </p>
        </>
      ),
      annotations: [
        {
          content: <Annotation priority={3}>Les Franchises</Annotation>,
          position: { x: 6, y: 35 },
          // position_mobile: { x: 6, y: 38 },
        },
        {
          content: <Annotation priority={3}>Eaux-Vives</Annotation>,
          position: { x: 60, y: 48 },
          position_mobile: { x: 53, y: 50 },
        },
        {
          content: <Annotation priority={3}>Petit-Saconnex</Annotation>,
          position: { x: 40, y: 28 },
          position_mobile: { x: 32, y: 31 },
        },

        {
          content: (
            <CircleAnnotation
              size={isMobile ? 50 : 90}
              angle={isMobile ? 90 : 60}
            >
              Saint-Jean Charmilles
            </CircleAnnotation>
          ),
          position: { x: 30, y: 41 },
          position_mobile: { x: 23, y: 45 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 40 : 55}
              angle={isMobile ? 330 : 280}
            >
              Pâquis
            </CircleAnnotation>
          ),
          position: { x: 57, y: 37 },
          position_mobile: { x: 57, y: 40 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_6621_poor_mob.jpg')
        : require('../../../Content/Maps/maps_6621_poor.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_6621_poor_mob_dm.jpg')
        : require('../../../Content/Maps/maps_6621_poor_dm.jpg'),
    },
  ],
}
